import { render } from "./SimulationPoste.vue?vue&type=template&id=1dde48da&ts=true"
import script from "./SimulationPoste.vue?vue&type=script&lang=ts"
export * from "./SimulationPoste.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__